import PropTypes from "prop-types";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Description, Image, Title } from "@/ui";
import classes from "./styles.module.scss";

export default function Benefits({ className, containerClassName, title, items }) {
  return (
    <div className={clsx(className, classes.benefits)}>
      <Container className={containerClassName}>
        <Title title={title} className="mb-4" />
        <Row>
          {items.map((i, k) => (
            <Col key={k} xs={12} md={4} className="mb-4">
              <div className={classes.benefits__item}>
                <Image img={i.icon} size="50x50" alt="" />
                <div>
                  <Title title={i.title} tag="h3" className="text-tertiary h5" />
                  <Description description={i.text} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

Benefits.defaultProps = {
  className: "py-5",
  containerClassName: "mw-xl",
};

Benefits.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string
};
